import React, { FC, memo } from 'react'

// props
interface IProps {
  /** 数量 */
  cnt: number;
  /** 名称 */
  name: string;
  /** 是否售罄 */
  notSale?: boolean;
}

const MultiChooseItem: FC<IProps> = ({ cnt, name, notSale }) => {
  return (
    <div>{name} {cnt > 0 ? 'x' : ''}{cnt}{notSale ? `（${i18n.t('common.soldout')}）` : ''}</div>
  )
}

export default memo(MultiChooseItem)
